export default __webpack_public_path__ + "static/NXL-hero-bg-full-words-efd778a1978dbde993dd4c5f9b4fc7a2.jpg";